module.exports = __webpack_public_path__ + "assets/img/like.8c32f060.png";